/* tslint:disable */
/* eslint-disable */
/* @relayHash bbdea7b10018129d66a338db21f1b563 */

import { ConcreteRequest } from "relay-runtime";
export type InterviewNotesModal_TokenQueryVariables = {
    backgroundCheckUUID: string;
};
export type InterviewNotesModal_TokenQueryResponse = {
    readonly interviewNotesFormToken: string;
};
export type InterviewNotesModal_TokenQuery = {
    readonly response: InterviewNotesModal_TokenQueryResponse;
    readonly variables: InterviewNotesModal_TokenQueryVariables;
};



/*
query InterviewNotesModal_TokenQuery(
  $backgroundCheckUUID: UUID!
) {
  interviewNotesFormToken(backgroundCheckUUID: $backgroundCheckUUID)
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "backgroundCheckUUID",
            "type": "UUID!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "interviewNotesFormToken",
            "args": [
                {
                    "kind": "Variable",
                    "name": "backgroundCheckUUID",
                    "variableName": "backgroundCheckUUID"
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "InterviewNotesModal_TokenQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "InterviewNotesModal_TokenQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "InterviewNotesModal_TokenQuery",
            "id": null,
            "text": "query InterviewNotesModal_TokenQuery(\n  $backgroundCheckUUID: UUID!\n) {\n  interviewNotesFormToken(backgroundCheckUUID: $backgroundCheckUUID)\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '5926b40cd04fb6bb7e75e8e0be7d3c5d';
export default node;
